import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { CheckCircle, Hourglass } from '@phosphor-icons/react';

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') { setStatus('paid'); return; }
      } catch (e) { console.warn('Payment status poll failed, retrying:', e?.message); }
      if (++tries < 8) setTimeout(poll, 2000); else setStatus('pending');
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto text-center py-20" data-testid="payment-success-page">
      {status === 'paid' ? (
        <>
          <CheckCircle size={64} weight="fill" className="text-green-700 mx-auto mb-4" />
          <h1 className="font-display text-3xl font-extrabold tracking-tight mb-2">Payment received</h1>
          <p className="text-slate-500 mb-6">The invoice has been updated and the payment audited.</p>
        </>
      ) : status === 'pending' ? (
        <>
          <Hourglass size={64} className="text-amber-500 mx-auto mb-4" />
          <h1 className="font-display text-3xl font-extrabold tracking-tight mb-2">Payment processing</h1>
          <p className="text-slate-500 mb-6">We haven't received confirmation yet. Check the fees page shortly.</p>
        </>
      ) : (
        <p className="font-mono-label text-xs uppercase text-slate-400">Confirming payment...</p>
      )}
      <Link to="/fees" data-testid="back-to-fees-link" className="text-sm font-medium text-blue-600 hover:underline">Back to Fees</Link>
    </div>
  );
}
